import PropTypes from 'prop-types';
import React from 'react';
import Icon from 'react-icons-kit';
import {ic_arrow_forward} from 'react-icons-kit/md/ic_arrow_forward';
import {ic_check_circle} from 'react-icons-kit/md/ic_check_circle';
import styled, { useTheme } from 'styled-components';
import {Circle} from 'better-react-spinkit';

const Root = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 5px 5px 5px;
`;

const InputLabel = styled.div`
  font-size: 0.7em;
  text-align: right;
  padding: 0 2px 0 0;
`;

const SymbolicDateInput = styled.input`
  padding: 0 5px;
  width: 100%;
  text-align: left;
  border-radius: 3px;
  font-size: 1em;
  border: 1px solid #9e9e9e;
  line-height: 22px;
  &::placeholder {
    font-size: 12px;
  }
`;

const loadingStyle = {
  position: 'absolute',
  left: 0,
  top: 0,
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#dededea6',
  height: '100%',
}

const SymbolicGoIcon = styled.div`
  color: ${({theme}) => theme?.primaryColor};
`;

const goIconStyle = {
  display: 'inline-flex',
  cursor: 'pointer',
};

const SymbolicInput = (props) => {
  const { disabled, symbolicDate, onChangeSymbolicDate, loading } = props;
  const [value, setValue] = React.useState(symbolicDate);
  const theme = useTheme();

  /* Ensures the symbolic date input is updated whenever symbolic date is changed externally */
  React.useEffect(() => {
    setValue(symbolicDate);
  }, [symbolicDate]);

  const symbolicMatch = symbolicDate?.length > 0 && symbolicDate === value;

  const onChange = React.useCallback((event) => {
    setValue(event.target.value?.toUpperCase());
  }, []);


  const goIcon = symbolicMatch ? ic_check_circle : ic_arrow_forward;
  
  const onClickGoIcon = React.useCallback(() => {
    onChangeSymbolicDate(value);
  }, [onChangeSymbolicDate, value]);
  
  const onKeyDownInput = React.useCallback(({key}) => {
    if (key === 'Enter') {
      onClickGoIcon();
    }
  }, [onClickGoIcon]);

  return (
    <Root>
      {loading && (<Circle color={theme.primaryColor} size={16} style={loadingStyle}/>)}
      <InputLabel>Symbolic Date:</InputLabel>
      <SymbolicDateInput
        onKeyDown={onKeyDownInput}
        onChange={onChange}
        value={value ?? ''}
        disabled={disabled || loading}
      />
      <SymbolicGoIcon>
        <Icon icon={goIcon} size={16} onClick={onClickGoIcon} style={goIconStyle}/>
      </SymbolicGoIcon>
    </Root>
  );
};

SymbolicInput.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  symbolicDate: PropTypes.string,
  onChangeSymbolicDate: PropTypes.func,
};

export default SymbolicInput;

